import { gql } from 'graphql.macro';

export const GetGoogleMapsApiKey = gql`

    query getGoogleApiKey {
        googleApiKey
    }
`;